import { createContext, useContext } from "react";

export const TableSetupContext = createContext();

export function useTableSetupContext() {
  return useContext(TableSetupContext);
}
